import { Component, Input, OnInit } from '@angular/core';
import { MeetingInfo } from './meeting-info';
import { Observable } from 'rxjs';
import { BookMeNowStoreService } from '../../book-me-now-store.service';
import { map } from 'rxjs/operators';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-meeting-info',
  templateUrl: './meeting-info.component.html',
  styleUrls: ['./meeting-info.component.scss'],
  standalone: false,
})
export class MeetingInfoComponent implements OnInit {
  @Input() existingMeeting: MeetingInfo; // Input for existing meeting info

  timezoneOffset$: Observable<string>; // Observable for timezone offset
  meetingMinuteDuration$: Observable<number>; // Observable for meeting duration in minutes
  meetingDescription$: Observable<string>; // Observable for meeting description
  isMobile$: Observable<boolean>; // Observable to check if the view is mobile
  inPersonLocation$: Observable<string>;
  location$: Observable<string>;

  constructor(
    private readonly bookMeNowStoreService: BookMeNowStoreService,
    private readonly breakpointObserver: BreakpointObserver
  ) {}

  ngOnInit(): void {
    // Observes breakpoints to determine if the device is mobile
    this.isMobile$ = this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Handset])
      .pipe(map((result) => result.matches));

    // Initializing observables from the service
    this.timezoneOffset$ = this.bookMeNowStoreService.timezoneOffset$;
    this.meetingMinuteDuration$ =
      this.bookMeNowStoreService.meetingTypeDuration$;
    this.inPersonLocation$ = this.bookMeNowStoreService.inPersonLocation$;
    this.location$ = this.bookMeNowStoreService.meetingLocation$;
    this.meetingDescription$ =
      this.bookMeNowStoreService.meetingTypeDescription$.pipe(
        map((description) => description?.trim() || '') // Use optional chaining for trimming
      );
  }
}
